/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ProfilesList from "examples/Lists/ProfilesList";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHobbyData } from "../../../../redux/slices/hobbyDataSlice";
import { baseUrl } from "services/axiosInstance";
import { useNavigate } from "react-router-dom";

function OrdersOverview() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { hobbyData, error, loading } = useSelector((state) => state.hobbyData);
  const handleApiCall = async () => {
    try {
      dispatch(getHobbyData());
    } catch (e) {
      console.log("e: ", e);
    }

  };

  useEffect(() => {
    handleApiCall();
  }, []);
  return (
    <Card sx={{ height: 438, overflow: "hidden" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h5" fontWeight="medium"
          onClick={() => navigate("/hobbies")}
          style={{ cursor: "pointer" }}
        >
          Hobbies
        </MDTypography>
      </MDBox>
      <MDBox p={2} >
        <Grid container spacing={2}>
          {Array.isArray(hobbyData) &&
            hobbyData.slice(0, 13).map((category) =>
              category.hobbies.map((hobby) => (
                <Grid item xs={12} sm={6} md={4} key={hobby.id}>
                  <MDBox
                    component="li"
                    display="flex"
                    alignItems="center"
                    p={1}
                    borderRadius="md"
                    sx={{ backgroundColor: "#f7f7f7", cursor: "pointer" }}
                    onClick={() => navigate(`/hobbies?categoryId=${category.id}`)}

                  >
                    <MDBox mr={2}>
                      <img
                        src={hobby.icon && `${baseUrl}${hobby.icon}`}
                        alt=""
                        style={{ width: 30, height: 30, objectFit: "contain" }}
                      />
                    </MDBox>
                    <MDTypography variant="button" fontWeight="medium">
                      {hobby.hobbieName}
                    </MDTypography>
                  </MDBox>
                </Grid>
              ))
            )}
  
        </Grid>
      </MDBox>
    </Card>

  );
}

export default OrdersOverview;
